import React, {useState} from "react";
import {
    Box, Typography, Button, TextField, InputAdornment, Divider
} from "@mui/material";
import { useOutletContext, } from "react-router-dom";
import BulkEsignTable from "../../components/BulkEsign/bulkEsignTable";
import { useSelector } from "react-redux";
import { esignIcons } from "../../components/Esign/icons";
import Premium from "../../components/Premium/premium";

const BulkEsign = () => {
    const { open } = useOutletContext();
    const [bulkTableData, setBulkTableData] = useState([])

    return (
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
          marginLeft: open ? "240px" : "100px",
          transition: "margin 0.3s ease",
          height: "100vh",
          display: "flex",
          background: "#f9f9f9",
        }}
      >
        <Box
          mt={10}
          style={{
            borderRadius: "12px",
            textAlign: "center",
            background: "#fff",
            width: "100%",
            height: bulkTableData.length <= 0 ? "calc(100% - 73px)" : "calc(100% - 133px)",
            marginLeft: open ? "" : "1em",
          }}
        >
            <Box sx={{ display: "flex", alignItems:'center', justifyContent: "space-between", padding: "25px" }}>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", ml: 2 }}>
                    Bulk eSign
                </Typography>
                <Box sx={{  }}>
                    <TextField
                        placeholder="Search..."
                        type="number"
                        variant="outlined"
                        // onChange={handleSearchChange}
                        onKeyDown={(e) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                        }}
                        onPaste={(e) => {
                            const paste = e.clipboardData.getData('text');
                            if (!/^\d+$/.test(paste)) {
                              e.preventDefault();
                            }
                        }}
                        sx={{
                        boxSizing: "border-box",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        borderColor: "#E8E8E9",
                        borderWidth: "5px",
                        "& .MuiOutlinedInput-root": {
                            borderColor: "#E8E8E9",
                            backgroundColor: "none",
                            "&:hover fieldset": {
                            borderColor: "#E8E8E9",
                            },
                            "&.Mui-focused fieldset": {
                            borderColor: "#E8E8E9",
                            },
                        },
                        }}
                        InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                            {esignIcons.searchIcon}
                            </InputAdornment>
                        ),
                        sx: { 
                            borderRadius: "10px",
                            width: 410,
                            height: 40,
                            fontSize: "16px",
                            fontWeight: "500",
                            "& input::-ms-reveal, & input::-ms-clear": {
                                display: "none",
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                display: "none",
                                WebkitAppearance: "none",
                                margin: 0,
                            },
                            "& input[type=number]": {
                                MozAppearance: "textfield",
                            },
                        },
                        }}
                    />
                </Box>
            </Box>
            <Divider />
            {bulkTableData.length <= 0 && (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative", left: "50%", top: "41%", transform: "translate(-50%, -50%)"  }}>
                    <img src={`${process.env.PUBLIC_URL}/images/not_found.png`} alt="Premium" style={{ height: 166 }} />
                    <Typography variant="caption" sx={{ fontSize: "18px", fontWeight: "600", color: "#000000" }}>
                        No Bulk eSign Activity Found!
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}>
                        Get started by uploading your documents for faster,<br /> multi-signature workflows.
                    </Typography>
                    <Button variant="contained" sx={{ mt: "25px", width: '199px', height: 40, color: "#FFFFFF", background:"#185CB7", textTransform: "none", fontSize: "14px", borderRadius: "12px", border: "none", boxShadow: "none", fontWeight: "500", display: "flex", alignItems:"center", gap:1 }} >
                        {esignIcons.fileUploadIcon}Upload Bulk E-SIgn
                    </Button>
                </Box>
            )}
            {bulkTableData > 0 && <BulkEsignTable />}
            <Premium />
        </Box>
      </Box>
    );
};

export default BulkEsign;
